import { call, put, takeLatest } from 'redux-saga/effects';

import { getSNUS } from '../../services/API';
import { actionTypes, requestFailure, requestSuccess } from './actions';

function* getData(action) {
  const responseSnus = yield call(getSNUS, action.payload);
  if (responseSnus.isOk) {
    yield put(requestSuccess(responseSnus.data));
  } else {
    yield put(requestFailure(responseSnus.error));
  }
}

export default function* snusSaga() {
  yield takeLatest(actionTypes.REQUEST_START, getData);
  yield takeLatest(actionTypes.REQUEST_START_SKIP_LOADING, getData);
}
